import _ from "lodash"

/**
 * Ordena la lista plana de zonas dejando cada subzona debajo de su zona padre.
 */
export const ordenarRegiones = regions => {
  const padres = (regions || []).filter(region => !region.parent_id)
  const ordenados = []

  _.orderBy(padres, ["name"]).forEach(padre => {
    ordenados.push(padre)
    _.orderBy(
      (regions || []).filter(region => region.parent_id === padre.id),
      ["name"]
    ).forEach(hija => ordenados.push(hija))
  })

  // zonas huérfanas (su padre no está en la lista) al final, para no perderlas
  ;(regions || []).forEach(region => {
    if (!ordenados.some(item => item.id === region.id)) ordenados.push(region)
  })

  return ordenados
}

export const etiquetaRegion = (region, regions) => {
  if (!region.parent_id) return region.name
  const padre = (regions || []).find(item => item.id === region.parent_id)
  return padre ? `${padre.name} | ${region.name}` : region.name
}
